/** Browser-local shown-once backstop for the post-auth segmentation prompt. */

/** localStorage key prefix for the per-user shown-once backstop. */
const PREQUAL_PROMPTED_KEY_PREFIX = 'prequal.post_auth_prompted:';

function promptedKey(userId: string): string {
  return `${PREQUAL_PROMPTED_KEY_PREFIX}${userId}`;
}

/** Shown-once backstop: has this user already been prompted with the wizard? */
export function hasPrequalPrompted(userId: string): boolean {
  try {
    return window.localStorage.getItem(promptedKey(userId)) === '1';
  } catch {
    // Private mode / quota denial: treat as not-prompted. The Auth0 first-login
    // claim bounds this to brand-new users, so a re-prompt in a storage-denied
    // session is a rare, low-harm edge — never re-prompts the installed base.
    return false;
  }
}

/**
 * Mark the user as prompted. Called when the wizard is SHOWN (on prompt), NOT on
 * completion — so a user who skips or abandons is shown exactly once.
 */
export function markPrequalPrompted(userId: string): void {
  try {
    window.localStorage.setItem(promptedKey(userId), '1');
  } catch {
    // Ignore storage failures (private mode, quota).
  }
}
